"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.intersection = exports.valuesNotIn = exports.getOptionForValue = void 0;
function getOptionForValue(options, value) {
    return options.find((item) => item.value === value);
}
exports.getOptionForValue = getOptionForValue;
function valuesNotIn(a, b) {
    return a.filter(value => b.indexOf(value) === -1);
}
exports.valuesNotIn = valuesNotIn;
function intersection(a, b) {
    return a.filter(value => b.indexOf(value) !== -1);
}
exports.intersection = intersection;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0cmFjdG9ycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9leHRyYWN0b3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILFNBQWdCLGlCQUFpQixDQUEyQixPQUFZLEVBQUUsS0FBVTtJQUNsRixPQUFRLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUFPLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxLQUFLLEtBQUssS0FBSyxDQUFrQixDQUFDO0FBQzNFLENBQUM7QUFGRCw4Q0FFQztBQUVELFNBQWdCLFdBQVcsQ0FBQyxDQUFRLEVBQUUsQ0FBUTtJQUM1QyxPQUFPLENBQUMsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7QUFDcEQsQ0FBQztBQUZELGtDQUVDO0FBRUQsU0FBZ0IsWUFBWSxDQUFDLENBQVEsRUFBRSxDQUFRO0lBQzdDLE9BQU8sQ0FBQyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUNwRCxDQUFDO0FBRkQsb0NBRUMifQ==